<template>
    <CalendarGrid
        :class="cn('w-full table-fixed border-separate border-spacing-x-0 border-spacing-y-2', props.class)"
        v-bind="forwardedProps"
    >
        <slot />
    </CalendarGrid>
</template>

<script setup lang="ts">
import type { CalendarGridProps } from 'reka-ui';
import type { HTMLAttributes } from 'vue';
import { reactiveOmit } from '@vueuse/core';
import { CalendarGrid, useForwardProps } from 'reka-ui';
import { cn } from '@/lib/utils';

const props = defineProps<CalendarGridProps & { class?: HTMLAttributes['class'] }>();

const delegatedProps = reactiveOmit(props, 'class');

const forwardedProps = useForwardProps(delegatedProps);
</script>
